import type { ReactNode } from "react";
import { Outlet } from "react-router";

import { EmptyBlock } from "../components/States";
import { useCurrentUser } from "../lib/currentUser";
import { useTranslation } from "../lib/i18n";

/** Administration routes: the DAR only (the API enforces it too, this is the courtesy page). */
export function DarOnly() {
  const { t } = useTranslation();
  const me = useCurrentUser();
  if (!me.is_dar) {
    return (
      <div className="ada-page">
        <EmptyBlock
          icon="lock"
          title={t("Restricted to the DAR")}
          description={t("These screens belong to the resource allocation office.")}
        />
      </div>
    );
  }
  return <Outlet />;
}

/**
 * Pages about one's own staffing (CRA, requests). A DAR member whose account is not linked to a
 * Boond person can open the app, but has no assignments, requests or reports of their own.
 */
export function RequirePerson({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const me = useCurrentUser();
  if (!me.linked) {
    return (
      <EmptyBlock
        icon="user"
        title={t("Account not linked to a Boond person")}
        description={t(
          "Your DAR account is not linked to any Boond person: this page is about the people assigned to projects. Link your account from Administration › People.",
        )}
      />
    );
  }
  return <>{children}</>;
}
